var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-4" };
const _hoisted_2 = { class: "flex justify-between w-full" };
const _hoisted_3 = {
    key: 0,
    class: "p-2 rounded-full bg-success-50"
};
const _hoisted_4 = { class: "p-2 rounded-full bg-success-100" };
import { useRecord } from '@/composition/useRecord';
import { DomainConnectServices } from '@/service/DomainConnectService';
import { Globe02Icon, XCloseIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIModal } from '@gohighlevel/ghl-ui';
import { computed, inject, ref } from 'vue';
import { DOMAIN_CONNECT_PRODUCT_TYPES, TEMPLATE_LOOKUP, } from '../../types';
import DomainConnectAuthorization from './DomainConnectAuthorization.vue';
import DomainConnectForm from './DomainConnectForm.vue';
import DomainConnectLoader from './DomainConnectLoader.vue';
import DomainConnectOtherProviders from './DomainConnectOtherProviders.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DomainConnectModal',
    props: {
        showModal: { type: Boolean },
        configuration: null
    },
    emits: ["close"],
    setup(__props, { emit }) {
        var _a;
        const props = __props;
        const route = inject('route');
        const showRecords = ref(false);
        const showLoader = ref(false);
        const loadingPercentage = ref(0);
        const provider = ref(null);
        const payloadData = ref(undefined);
        const template = ref();
        const locationId = (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id;
        const intervalRef = ref();
        const { addRecords, recordTableData, resetRecords, authorizeUrl, fetchAuthorizationUrl, isProcessing: isRecordAddingProcessing, } = useRecord();
        const closeModal = () => {
            emit('close');
            setTimeout(() => {
                // reset state
                resetState();
            }, 500);
        };
        const resetState = () => {
            clearInterval(intervalRef.value);
            showRecords.value = false;
            resetRecords();
            loadingPercentage.value = 0;
            payloadData.value = undefined;
            provider.value = undefined;
            showLoader.value = false;
            template.value = undefined;
        };
        const getTemplate = ({ domain, subDomainValue, addRootOrWWW, }) => {
            if (props.configuration.team === DOMAIN_CONNECT_PRODUCT_TYPES.EMAIL) {
                template.value = TEMPLATE_LOOKUP.email;
            }
            else if (props.configuration.team === DOMAIN_CONNECT_PRODUCT_TYPES.WORDPRESS &&
                domain) {
                if (subDomainValue) {
                    template.value = TEMPLATE_LOOKUP.cname;
                }
                else {
                    template.value = TEMPLATE_LOOKUP.aTxtSsl;
                }
            }
            else if (domain) {
                if (addRootOrWWW) {
                    template.value = TEMPLATE_LOOKUP.aCname;
                }
                else if (subDomainValue) {
                    template.value = TEMPLATE_LOOKUP.cname;
                }
                else {
                    template.value = TEMPLATE_LOOKUP.a;
                }
            }
        };
        const getProviderDetails = (domain, productArea, template, locationId) => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield DomainConnectServices.verifyDNSProviderTemplateData({
                    domain,
                    productArea,
                    template,
                    locationId,
                });
                provider.value = data.provider;
            }
            catch (err) {
                provider.value = null;
            }
        });
        const animateLoader = (total) => {
            return new Promise(resolve => {
                intervalRef.value = setInterval(() => {
                    loadingPercentage.value += 10;
                    if (loadingPercentage.value === total) {
                        clearInterval(intervalRef.value);
                        resolve('Loading Finished');
                    }
                }, 500);
            });
        };
        const addRecordsManually = ({ domain, subDomainValue, addRootOrWWW, }) => __awaiter(this, void 0, void 0, function* () {
            getTemplate({
                domain,
                subDomainValue,
                addRootOrWWW,
            });
            payloadData.value = {
                domain,
                subDomainValue: subDomainValue || undefined,
                addRootOrWWW,
            };
            provider.value = null;
            yield addRecords({
                domain: domain,
                subDomainValue: subDomainValue,
                team: props.configuration.team,
                template: template.value,
            });
            showRecords.value = true;
        });
        const checkProvider = ({ domain, subDomainValue, addRootOrWWW, }) => __awaiter(this, void 0, void 0, function* () {
            showLoader.value = true;
            loadingPercentage.value = 0;
            // fetching Provider State
            getTemplate({
                domain,
                subDomainValue,
                addRootOrWWW,
            });
            yield getProviderDetails(domain, props.configuration.team, template.value, locationId !== null && locationId !== void 0 ? locationId : undefined);
            yield animateLoader(30);
            // fetching DNS State
            payloadData.value = {
                domain,
                subDomainValue: subDomainValue || undefined,
                addRootOrWWW,
            };
            yield addRecords({
                domain: domain,
                subDomainValue: subDomainValue,
                team: props.configuration.team,
                template: template.value,
            });
            yield animateLoader(70);
            // Fetching Url state
            if (provider.value) {
                yield fetchAuthorizationUrl({
                    provider: provider.value,
                    domain,
                    subDomainValue,
                    team: props.configuration.team,
                    template: template.value,
                });
            }
            yield animateLoader(100);
            showLoader.value = false;
            showRecords.value = true;
        });
        const checkFlag = computed(() => {
            const showForm = !showRecords.value && !showLoader.value;
            const isLoading = showLoader.value;
            const showOtherProvider = !provider.value && payloadData.value && template.value;
            const showAuthorization = provider.value && payloadData.value && template.value && authorizeUrl.value;
            return {
                showForm,
                isLoading,
                showOtherProvider,
                showAuthorization,
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                width: 580,
                show: __props.showModal
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                                (!showLoader.value && !showRecords.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createVNode(_unref(Globe02Icon), { class: "w-6 h-6 stroke-success-600" })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createVNode(_unref(XCloseIcon), {
                                class: "w-6 h-6 cursor-pointer stroke-gray-500",
                                onClick: closeModal
                            })
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    (_unref(checkFlag).showForm)
                        ? (_openBlock(), _createBlock(DomainConnectForm, {
                            key: 0,
                            isRecordAddingProcessing: _unref(isRecordAddingProcessing),
                            configuration: __props.configuration,
                            onNextStep: checkProvider,
                            onManualFlow: addRecordsManually
                        }, null, 8, ["isRecordAddingProcessing", "configuration"]))
                        : (_unref(checkFlag).isLoading)
                            ? (_openBlock(), _createBlock(DomainConnectLoader, {
                                key: 1,
                                "loading-percentage": loadingPercentage.value
                            }, null, 8, ["loading-percentage"]))
                            : (_unref(checkFlag).showOtherProvider)
                                ? (_openBlock(), _createBlock(DomainConnectOtherProviders, {
                                    key: 2,
                                    domain: payloadData.value.domain,
                                    configuration: __props.configuration,
                                    template: template.value,
                                    "sub-domain-value": payloadData.value.subDomainValue,
                                    "record-table-data": _unref(recordTableData),
                                    team: props.configuration.team,
                                    onCloseModal: closeModal,
                                    onResetState: resetState
                                }, null, 8, ["domain", "configuration", "template", "sub-domain-value", "record-table-data", "team"]))
                                : (_unref(checkFlag).showAuthorization)
                                    ? (_openBlock(), _createBlock(DomainConnectAuthorization, {
                                        key: 3,
                                        provider: provider.value,
                                        domain: payloadData.value.domain,
                                        "sub-domain-value": payloadData.value.subDomainValue,
                                        "authorize-url": _unref(authorizeUrl),
                                        template: template.value,
                                        configuration: __props.configuration,
                                        "record-table-data": _unref(recordTableData),
                                        team: props.configuration.team,
                                        onCloseModal: closeModal,
                                        onResetState: resetState
                                    }, null, 8, ["provider", "domain", "sub-domain-value", "authorize-url", "template", "configuration", "record-table-data", "team"]))
                                    : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["show"]));
        };
    }
});
